module.exports = __webpack_public_path__ + "static/media/pink-green-flower.5658056b.jpg";